import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class CodeBlockRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.CodeBlock', 'CodeBlock');
  }

  protected validate({ args }: CanonicalValidateArgs): void {
    type CBArgs = Extract<RcStep.Arguments, { argumentKind: 'CodeBlock' }>;
    const a = args as CBArgs;
    this.checkCodeBlockId(a);
  }

  /**
   * Check if the code block ID is valid.
   * @param args - The arguments of the step.
   * @returns True if the code block ID is valid, false otherwise.
   */
  private checkCodeBlockId(
    args: Extract<RcStep.Arguments, { argumentKind: 'CodeBlock' }>,
  ): void {
    if (!args.codeBlockId) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Code Block required',
        fieldId: 'codeBlockId',
      });
    }
  }
}

export const CodeBlockValidation: ValidationRule =
  new CodeBlockRule().toValidationRule();
